<template>
  <div class="app-confirm-email-succeeded">
    <Succeeded :back-button-href="backButtonHref" :back="none">
      <template #txtBefore><slot name="confirmEmailTxtBefore"></slot></template>
      <template #btnSuccessBack><slot name="confirmEmailBtnSuccessBack"></slot></template>
    </Succeeded>
  </div>
</template>

<script>
import Succeeded from '../../../../generic/Success2.vue'
import { mapActions } from 'vuex'
export default {
  name: 'ConfirmEmailSucceeded',
  components: { Succeeded },
  props: {
    backButtonHref: {
      Type: String,
      Default: '#'
    }
  },
  methods: {
    none () {
    },
    ...mapActions('emailConfirmation', [
      'switchView'
    ])
  },
  created () {
    this.switchView()
  }
}
</script>
